import { TweenMax } from 'gsap'

export default function showLogo (delay = 0) {
  let logo = document.querySelector('footer .logo')
  TweenMax.to(logo, 1, { opacity: 1, delay: delay })
}
